import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-notvisible-editmode",
  templateUrl: "./field-set-notvisible-editmode.component.html",
  styles: [],
})
export class FieldSetNotVisibleEditModeComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
